var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.169922 16.9057C0.169922 18.5766 1.4477 19.8544 3.11864 19.8544H16.8793C18.5503 19.8544 19.828 18.5766 19.828 16.9057V9.04244H0.169922V16.9057ZM16.8793 2.1621H14.9135V1.1792C14.9135 0.589451 14.5204 0.196289 13.9306 0.196289C13.3409 0.196289 12.9477 0.589451 12.9477 1.1792V2.1621H7.05026V1.1792C7.05026 0.589451 6.6571 0.196289 6.06736 0.196289C5.47761 0.196289 5.08445 0.589451 5.08445 1.1792V2.1621H3.11864C1.4477 2.1621 0.169922 3.43988 0.169922 5.11082V7.07663H19.828V5.11082C19.828 3.43988 18.5503 2.1621 16.8793 2.1621Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3435a9839424a5cfc85bb9bf97019608.svg";
export { ForwardRef as ReactComponent };